import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import {
  CalendarActions,
  DownloadButton,
} from "../../../../../scheduler/component/styled/scheduler";
import moment from "moment";

const CalendarHeader = ({ onDate, handleDateClick, handleDownloadPdf }) => {
  return (
    <>
      <DownloadButton>
        <button onClick={handleDownloadPdf}>스케쥴표 다운로드</button>
        <i>
          <span>?</span>
          <div className="tooltip">
            일정 변경 사항(추가, 수정, 삭제)에 따라 버전이 업데이트됩니다.
          </div>
        </i>
      </DownloadButton>
      <CalendarActions className="actions">
        <button onClick={() => handleDateClick(moment())} className="today">
          오늘
        </button>
        <div className="month">
          <button onClick={() => handleDateClick(moment(onDate).subtract(1, "month"), false)}>
            <BsChevronLeft />
          </button>
          <button onClick={() => handleDateClick(moment(onDate).add(1, "month"))}>
            <BsChevronRight />
          </button>
        </div>
      </CalendarActions>
    </>
  );
};

export default CalendarHeader;
